import { getLabelFromLink } from './get_label_from_link';

export const addLevel1ParentLabel = ( labelElements, $linkElement) =>
    labelElements.unshift(
        getLabelFromLink(
            $linkElement
                .parents('.navigation-level-1__item')
                .children().first()[0]
        )
    );
